/** Cross-origin session clear via ?loggedOut=1&returnUrl= redirect chain. */

export function relayLoggedOutOrigin(origin: string, nextUrl: string): string {
  const base = origin.replace(/\/+$/, '');
  return `${base}/?loggedOut=1&returnUrl=${encodeURIComponent(nextUrl)}`;
}

/**
 * Nest relays so the user visits each origin in `relayOrigins` order, then `finalUrl`.
 * (Origins are applied from last to first.)
 */
export function buildCrossAppRelayReturnUrl(
  relayOrigins: string[],
  finalUrl: string
): string {
  let url = finalUrl;
  for (let i = relayOrigins.length - 1; i >= 0; i--) {
    const origin = relayOrigins[i]?.trim();
    if (!origin) continue;
    url = relayLoggedOutOrigin(origin, url);
  }
  return url;
}

export function buildAuthAppLogoutUrl(options: {
  authAppUrl: string;
  relayOrigins: string[];
  finalReturnUrl: string;
  everywhere?: boolean;
  token?: string;
  refreshToken?: string;
  email?: string;
}): string {
  const auth = options.authAppUrl.replace(/\/+$/, '');
  const chained = buildCrossAppRelayReturnUrl(
    options.relayOrigins,
    options.finalReturnUrl
  );
  const url = new URL(`${auth}/logout`);
  url.searchParams.set('returnUrl', chained);
  url.searchParams.set(
    'everywhere',
    options.everywhere === false ? '0' : '1'
  );
  if (options.token) {
    url.searchParams.set('token', options.token);
  }
  if (options.refreshToken) {
    url.searchParams.set('refreshToken', options.refreshToken);
  }
  if (options.email) {
    url.searchParams.set('email', options.email);
  }
  return url.toString();
}

/** Walk nested `returnUrl` params to the final post-logout landing (strip relay flags). */
export function resolveFinalLogoutLandingUrl(chainUrl: string | null | undefined): string | null {
  if (!chainUrl?.trim()) {
    return null;
  }
  try {
    let current = chainUrl.trim();
    for (let depth = 0; depth < 12; depth++) {
      const parsed = new URL(current);
      const nested = parsed.searchParams.get('returnUrl')?.trim();
      if (nested) {
        current = nested;
        continue;
      }
      parsed.searchParams.delete('loggedOut');
      return parsed.href;
    }
  } catch {
    return null;
  }
  return null;
}
